module.exports = __webpack_public_path__ + "static/p3-c7aac2492ea6d16a0946fff7104ebbba.jpg";